import React, { useEffect, useState } from "react";
import { Alert, Box, Typography } from "@mui/material";
import KeyboardOutlinedIcon from "@mui/icons-material/KeyboardOutlined";
import { useTranslation } from "react-i18next";
import {
  dismissChatQueueKeyboardHint,
  isChatQueueKeyboardHintDismissed,
} from "./chatQueueHintStorage";

/**
 * Dica única (por workspace) sobre navegação entre solicitações via teclado.
 * Padrão visual: Alert info dismissível, como demais avisos do chat.
 */
const ConversationQueueKeyboardHint = ({ open = false, sx }) => {
  const { t } = useTranslation("chat");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!open || isChatQueueKeyboardHintDismissed()) {
      setVisible(false);
      return;
    }
    setVisible(true);
  }, [open]);

  if (!visible) return null;

  const handleDismiss = () => {
    dismissChatQueueKeyboardHint();
    setVisible(false);
  };

  return (
    <Alert
      severity="info"
      icon={<KeyboardOutlinedIcon fontSize="inherit" />}
      onClose={handleDismiss}
      sx={{
        borderRadius: 0,
        py: 0.75,
        px: { xs: 1.25, sm: 1.5 },
        alignItems: "flex-start",
        flexShrink: 0,
        "& .MuiAlert-message": { width: "100%", py: 0.125 },
        ...sx,
      }}
    >
      <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.35 }}>
        {t("queue.hintTitle", "Navegue entre solicitações pelo teclado")}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.35, lineHeight: 1.45 }}>
        {t(
          "queue.hintBody",
          "Use a seta para cima para a solicitação anterior e a seta para baixo para a próxima. Clique fora do campo de mensagem antes de usar o atalho. A ordem é a mesma da lista à esquerda."
        )}
      </Typography>
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          mt: 0.75,
          px: 0.75,
          py: 0.2,
          borderRadius: 1,
          bgcolor: "action.hover",
          fontSize: "0.75rem",
          fontWeight: 600,
          letterSpacing: "0.02em",
          color: "text.secondary",
        }}
      >
        {t("queue.hintShortcut", "↑  anterior  ·  ↓  próxima")}
      </Box>
    </Alert>
  );
};

export default ConversationQueueKeyboardHint;
